import { CartLinesUpdateEvent, CartErrorEvent, StandardEvents } from '@shopify/events';

const root = document.querySelector('[data-bb-pdp]');
const rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const scrollToEl = (el, off) => { if (!el) return; window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - off, behavior: rm ? 'auto' : 'smooth' }); };

const countEl = document.querySelector('[data-bb-cart-count]');
document.querySelector('[data-bb-cart-open]')?.addEventListener('click', (e) => {
  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(); }
});
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ detail, cart }) => {
    const n = detail?.items ? detail.items.reduce((s, i) => s + i.quantity, 0) : cart?.totalQuantity;
    if (countEl && typeof n === 'number') countEl.textContent = n;
  }).catch(() => {});
});

if (root) {
  const data = JSON.parse(root.querySelector('[data-bb-json]').textContent);
  const variants = new Map(data.variants.map((v) => [String(v.id), v]));
  const buy = root.querySelector('[data-bb-buy]');
  const form = document.getElementById('bb-form-');
  const atc = root.querySelector('[data-bb-atc]');
  const err = root.querySelector('[data-bb-err]');
  const sel1 = root.querySelector('[data-bb-size="1"]');
  const sel2a = root.querySelector('[data-bb-size="2a"]');
  const sel2b = root.querySelector('[data-bb-size="2b"]');
  const cards = [...root.querySelectorAll('[data-bb-bundle]')];
  const idInput = root.querySelector('[data-bb-id]');
  const qtyInput = root.querySelector('[data-bb-qty]');
  let bundle = 1;

  const fmt = (cents, f = data.moneyFormatShort) => {
    const n = (cents / 100);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toLocaleString('de-DE');
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }).replace(/<[^>]+>/g, '');
  };
  const short = (cents) => fmt(cents).replace(/\.00(?=\D*$)/, '');
  const pct = (was, now) => (was > now ? Math.floor(((was - now) * 100) / was) : 0);
  const set = (sel, txt) => { const el = root.querySelector(sel); if (el) el.textContent = txt; };
  const hideErr = () => { err.hidden = true; buy.classList.remove('has-err'); };
  const ready = () => (bundle === 1 ? !!sel1.value : !!(sel2a.value && sel2b.value));
  const activeVariant = () => variants.get(bundle === 1 ? sel1.value : sel2a.value) || variants.get(String(data.selectedVariant)) || data.variants[0];
  const buy2Disc = Math.round(data.buy2Discount * (Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1));

  const sticky = root.querySelector('[data-bb-sticky]');
  const stickySub = root.querySelector('[data-bb-sticky-sub]');
  const stickyBtn = root.querySelector('[data-bb-sticky-btn]');
  function renderSticky() {
    if (!sticky) return;
    const v = activeVariant();
    const price = bundle === 2 ? v.price * 2 - buy2Disc : v.price;
    const sizes = bundle === 2 ? (ready() ? `${variants.get(sel2a.value).title} + ${variants.get(sel2b.value).title}` : 'Choose size') : (sel1.value ? `Size ${variants.get(sel1.value).title}` : 'Choose size');
    stickySub.textContent = `Buy ${bundle} · ${sizes} · ${fmt(price)}`;
    stickyBtn.textContent = ready() ? 'Add to cart' : 'Choose size';
  }

  function renderPrices() {
    const v = activeVariant();
    const b1 = v.price, b1w = v.compare;
    const b2 = v.price * 2 - buy2Disc, b2w = v.compare * 2;
    set('[data-bb-b1-price]', fmt(b1)); set('[data-bb-b1-was]', fmt(b1w)); set('[data-bb-b1-save]', `SAVE ${pct(b1w, b1)}%`);
    set('[data-bb-b2-price]', fmt(b2)); set('[data-bb-b2-was]', fmt(b2w)); set('[data-bb-b2-save]', `SAVE ${pct(b2w, b2)}%`);
    set('[data-bb-b2-each]', short(Math.round(b2 / 2)));
    const now = bundle === 2 ? b2 : b1, was = bundle === 2 ? b2w : b1w;
    set('[data-bb-price-now]', fmt(now, data.moneyFormat)); set('[data-bb-price-was]', fmt(was)); set('[data-bb-price-save]', `SAVE ${pct(was, now)}%`);
    renderSticky();
  }

  function syncForm() {
    const v = variants.get(bundle === 1 ? sel1.value : sel2a.value);
    if (v) {
      idInput.value = v.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    qtyInput.value = bundle === 2 ? 2 : 1;
    const anyAvail = bundle === 1 ? (!sel1.value || variants.get(sel1.value)?.available) : true;
    atc.disabled = !anyAvail;
  }

  function pickBundle(n) {
    bundle = n;
    cards.forEach((c) => c.setAttribute('aria-checked', String(c.dataset.bbBundle === String(n))));
    if (n === 2 && !sel2a.value && sel1.value) sel2a.value = sel1.value;
    if (n === 1 && !sel1.value && sel2a.value) sel1.value = sel2a.value;
    hideErr(); syncForm(); renderPrices();
  }
  cards.forEach((c) => {
    c.addEventListener('click', (e) => { if (e.target.closest('select')) return; pickBundle(Number(c.dataset.bbBundle)); });
    c.addEventListener('keydown', (e) => { if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('select')) { e.preventDefault(); pickBundle(Number(c.dataset.bbBundle)); } });
  });
  [sel1, sel2a, sel2b].forEach((s) => s.addEventListener('change', () => { hideErr(); syncForm(); renderPrices(); }));

  const urlV = new URL(window.location.href).searchParams.get('variant');
  if (urlV && variants.has(urlV)) sel1.value = urlV;

  const bands = [...root.querySelectorAll('[data-bb-band]')];
  const breed = root.querySelector('[data-bb-breed]');
  const finder = root.querySelector('[data-bb-finder]');
  const fText = root.querySelector('[data-bb-finder-text]');
  const fIcon = root.querySelector('[data-bb-finder-icon]');
  const BREEDS = { chihuahua: 0, yorkie: 0, pomeranian: 0, maltese: 0, pug: 0, dachshund: 0, 'jack russell': 0, 'french bulldog': 0, frenchie: 0, cavalier: 0, corgi: 1, beagle: 0, 'cocker spaniel': 1, 'border collie': 1, 'australian shepherd': 2, aussie: 2, bulldog: 2, springer: 1, 'pit bull': 2, pitbull: 2, boxer: 2, husky: 2, doodle: 2, labrador: 2, lab: 2, golden: 2, 'german shepherd': 3, rottweiler: 3, bernese: 3, mastiff: 4, 'great dane': 4, newfoundland: 4, 'saint bernard': 4 };
  const variantBySize = (size) => data.variants.find((v) => v.title.toUpperCase() === String(size).toUpperCase());
  function applyBand(i, fromBreed) {
    bands.forEach((b, k) => b.setAttribute('aria-checked', String(k === i)));
    if (!fromBreed) breed.value = '';
    const size = bands[i]?.dataset.size;
    const v = variantBySize(size);
    if (v) { sel1.value = String(v.id); if (bundle === 2) sel2a.value = String(v.id); }
    finder.hidden = false; finder.classList.remove('is-miss'); fIcon.textContent = '✓';
    fText.textContent = `Suggested size: ${size}. Confirm with the size chart below.`;
    hideErr(); syncForm(); renderPrices();
  }
  bands.forEach((b, i) => b.addEventListener('click', () => applyBand(i, false)));
  breed.addEventListener('input', () => {
    const q = breed.value.trim().toLowerCase();
    let hit = null;
    if (q.length >= 3) Object.keys(BREEDS).forEach((k) => { if (hit === null && (q.includes(k) || k.startsWith(q))) hit = BREEDS[k]; });
    if (hit !== null && bands[hit]) { applyBand(hit, true); return; }
    if (q.length >= 3) {
      bands.forEach((b) => b.setAttribute('aria-checked', 'false'));
      finder.hidden = false; finder.classList.add('is-miss'); fIcon.textContent = '!';
      fText.textContent = "We don't have that breed listed. Pick a weight above, or message us for help.";
    }
  });

  const thumbs = [...root.querySelectorAll('[data-bb-thumb]')];
  const mainImg = root.querySelector('[data-bb-main]');
  const blur = root.querySelector('[data-bb-blur]');
  let idx = 0;
  function show(i) {
    idx = (i + thumbs.length) % thumbs.length;
    const t = thumbs[idx];
    mainImg.src = t.dataset.src; blur.src = t.dataset.src; mainImg.alt = t.dataset.alt; mainImg.dataset.fit = t.dataset.fit;
    thumbs.forEach((x, k) => x.setAttribute('aria-selected', String(k === idx)));
  }
  thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
  root.querySelector('[data-bb-prev]')?.addEventListener('click', () => show(idx - 1));
  root.querySelector('[data-bb-next]')?.addEventListener('click', () => show(idx + 1));
  thumbs.forEach((t) => { const im = new Image(); im.src = t.dataset.src; });

  const slides = [...root.querySelectorAll('[data-bb-rv-slide]')];
  const dots = [...root.querySelectorAll('[data-bb-rv-dot]')];
  let ri = 0, paused = false, timer;
  const showRv = (i) => { ri = i; slides.forEach((s, k) => (s.hidden = k !== i)); dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i))); };
  const startRv = () => { clearInterval(timer); timer = setInterval(() => { if (!paused && slides.length) showRv((ri + 1) % slides.length); }, 11000); };
  dots.forEach((d, i) => d.addEventListener('click', () => { showRv(i); startRv(); }));
  const rv = root.querySelector('[data-bb-rv]');
  if (rv) { ['mouseenter', 'focusin'].forEach((e) => rv.addEventListener(e, () => (paused = true))); ['mouseleave', 'focusout'].forEach((e) => rv.addEventListener(e, () => (paused = false))); }
  if (slides.length > 1) startRv();

  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on)); stickyBtn.tabIndex = on ? 0 : -1;
    }).observe(atc);
    stickyBtn.addEventListener('click', () => { if (ready()) form.requestSubmit(); else scrollToEl(root.querySelector('[data-bb-sizes]'), 90); });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!ready()) { err.hidden = false; buy.classList.add('has-err'); scrollToEl(root.querySelector('[data-bb-sizes]'), 90); return; }
    let items;
    if (bundle === 1) items = [{ id: Number(sel1.value), quantity: 1 }];
    else items = sel2a.value === sel2b.value ? [{ id: Number(sel2a.value), quantity: 2 }] : [{ id: Number(sel2a.value), quantity: 1 }, { id: Number(sel2b.value), quantity: 1 }];
    items = items.map((i) => ({ ...i, properties: { '🎁 Free gifts': 'Paw Balm + Anti-Slip Socks + Recovery eBook' } }));
    const sectionIds = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })), promise: deferred.promise }));
    atc.classList.add('is-loading'); atc.disabled = true;
    const refreshCart = async () => {
      const cic = document.querySelector('cart-items-component');
      if (cic) { await customElements.whenDefined('cart-items-component'); if (typeof cic.fetchCartData === 'function') return cic.fetchCartData(); }
      return fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    };
    try {
      const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: sectionIds.join(',') })
      }).then((r) => r.json());
      const cart = await refreshCart();
      const totalQty = items.reduce((s, i) => s + i.quantity, 0);
      if (res.status) {
        form.dispatchEvent(new CartErrorEvent({ error: res.message || 'Add to cart failed', code: 'INVALID', detail: { description: res.description, errors: res.errors } }));
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'bb-pdp', sourceId: 'bb-pdp', itemCount: totalQty, productId: String(data.productId) } });
        err.textContent = res.description || res.message || 'Could not add to cart.'; err.hidden = false;
      } else {
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'bb-pdp', sourceId: 'bb-pdp', itemCount: totalQty, productId: String(data.productId), sections: res.sections, didError: false } });
        if (countEl) countEl.textContent = cart.item_count;
      }
    } catch (error) {
      deferred.reject(error);
      form.dispatchEvent(new CartErrorEvent({ error: error?.message || 'Network error during add to cart', code: 'SERVICE_UNAVAILABLE' }));
    } finally {
      atc.classList.remove('is-loading'); syncForm();
    }
  });

  syncForm(); renderPrices();
}

const giftTpl = document.getElementById('bb-giftnote-tpl');
if (giftTpl) {
  let hasBrace = giftTpl.dataset.has === 'true';
  const pid = Number(giftTpl.dataset.product);
  const mq = window.matchMedia('(max-width: 749px)');
  const place = () => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    const notes = drawer.querySelectorAll('[data-bb-giftnote]');
    if (!hasBrace) { notes.forEach((n) => n.remove()); return; }
    const mobile = mq.matches;
    const target = mobile ? drawer.querySelector('.cart-drawer__items') : drawer.querySelector('.cart__ctas');
    if (!target) return;
    const ok = mobile ? target.lastElementChild?.matches('[data-bb-giftnote]') : target.previousElementSibling?.matches('[data-bb-giftnote]');
    if (ok && notes.length === 1) return;
    notes.forEach((n) => n.remove());
    const node = giftTpl.content.firstElementChild.cloneNode(true);
    if (mobile) { node.style.marginTop = '16px'; node.style.marginBottom = '16px'; target.append(node); }
    else target.before(node);
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(({ detail }) => { if (detail?.items) hasBrace = detail.items.some((i) => i.product_id === pid); requestAnimationFrame(place); setTimeout(place, 400); }).catch(() => {});
  });
  mq.addEventListener('change', place);
  const drawerEl = document.getElementById('cart-drawer');
  if (drawerEl) new MutationObserver(() => place()).observe(drawerEl, { childList: true, subtree: true });
  place();
}

const cr = document.querySelector('[data-bb-cr]');
if (cr) {
  const items = [...cr.querySelectorAll('[data-bb-cr-item]')];
  const nav = cr.querySelector('[data-bb-cr-pages]');
  const PER = 6, total = Math.ceil(items.length / PER);
  let cp = 1;
  const arrow = (d) => `<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="${d}"></path></svg>`;
  function render() {
    items.forEach((el, i) => (el.hidden = i < (cp - 1) * PER || i >= cp * PER));
    const nums = [...new Set([1, cp - 1, cp, cp + 1, total])].filter((n) => n >= 1 && n <= total).sort((a, b) => a - b);
    let h = `<button type="button" class="bb-cr__pg" aria-label="Previous page" data-go="${cp - 1}"${cp === 1 ? ' disabled' : ''}>${arrow('M15 5l-7 7 7 7')}</button>`;
    nums.forEach((n, i) => { if (i && n - nums[i - 1] > 1) h += '<span class="bb-cr__dots" aria-hidden="true">…</span>'; h += `<button type="button" class="bb-cr__pg" aria-label="Page ${n}" data-go="${n}"${n === cp ? ' aria-current="page"' : ''}>${n}</button>`; });
    h += `<button type="button" class="bb-cr__pg" aria-label="Next page" data-go="${cp + 1}"${cp === total ? ' disabled' : ''}>${arrow('M9 5l7 7-7 7')}</button>`;
    nav.innerHTML = h;
  }
  nav.addEventListener('click', (e) => { const b = e.target.closest('[data-go]'); if (!b || b.disabled) return; cp = Number(b.dataset.go); render(); scrollToEl(cr, 12); });
  if (total > 1) render();
}
